import * as moment from 'moment';
import Model from "./Model";
import User from "./User";

class WalletItem extends Model {
  constructor(options) {
    super();
    (this as any).user = d => {
      return new User(d.data);
    };
    this.bind(options);
  }
  getExpired(): moment.Moment {
    let m = moment(this['expired_at']);
    return m;
  }
}

export default WalletItem;
